<template>
  <div class="space-y-12">
    <div>
      <h5 class="text-sm font-medium tracking-wide text-gray-700 mb-2">
        Name
        <template v-if="editable && editedAttributes.indexOf('name') === -1">
          <button
            class="inline hover:underline text-blue-600 focus:outline-none"
            @click="editAttribute('name')"
          >
            edit
          </button>
        </template>
      </h5>
      <h1
        v-if="editedAttributes.indexOf('name') === -1"
        v-text="name"
        class="text-xl font-medium"
      />
      <input
        v-else
        v-select
        type="text"
        v-model="wip.name"
        class="px-4 py-2 leading-5 text-sm border rounded hover:border-gray-700 focus:outline-none focus:border-gray-700 focus:ring ring-blue-500 ring-opacity-50 w-full"
        @blur="commitAttributeChanges('name')"
        @keydown.enter="commitAttributeChanges('name')"
        @keydown.esc="revertAttributeChanges('name')"
      />
    </div>

    <div>
      <h5 class="text-sm font-medium tracking-wide text-gray-700 mb-2">
        Description
        <template v-if="editable && editedAttributes.indexOf('requirements') === -1">
          <button
            class="inline hover:underline text-blue-600 focus:outline-none"
            @click="editAttribute('requirements')"
          >
            edit
          </button>
        </template>
      </h5>
      <pre
        v-if="editedAttributes.indexOf('requirements') === -1"
        v-text="requirements"
        class="text-sm whitespace-pre-wrap font-normal font-sans measure break-words"
      />
      <textarea
        v-else
        v-select
        v-model="wip.requirements"
        rows="10"
        class="px-4 py-2 leading-5 text-sm border rounded hover:border-gray-700 focus:outline-none focus:border-gray-700 focus:ring ring-blue-500 ring-opacity-50 w-full resize-none"
        @blur="commitAttributeChanges('requirements')"
        @keydown.ctrl.enter="commitAttributeChanges('requirements')"
        @keydown.esc="revertAttributeChanges('requirements')"
      />
    </div>
  </div>
</template>

<script>
import { kebabCase } from 'lodash-es';

export default {
  name: 'Attributes',

  props: {
    editable: Boolean,
    name: {
      type: String,
      default: '',
    },
    requirements: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      editedAttribute: null,
      wip: {},
    };
  },

  computed: {
    editedAttributes() {
      return Object.keys(this.wip);
    },
  },

  methods: {
    editAttribute(attribute) {
      this.wip = {
        ...this.wip,
        [attribute]: this[attribute],
      };
    },
    editAttributes(attributes) {
      attributes.forEach((attribute) => this.editAttribute(attribute));
    },
    commitAttributeChanges(attribute) {
      const { [attribute]: changedAttribute, ...remainingChangedAttributes } = this.wip;

      if (changedAttribute === undefined) {
        return;
      }

      this.$emit(`update:${kebabCase(attribute)}`, changedAttribute);

      this.wip = { ...remainingChangedAttributes };
    },
    commitAttributesChanges(attributes) {
      attributes.forEach((attribute) => this.commitAttributeChanges(attribute));
    },
    revertAttributeChanges(attribute) {
      const { [attribute]: changedAttribute, ...remainingChangedAttributes } = this.wip;

      if (changedAttribute === undefined) {
        return;
      }

      this.wip = { ...remainingChangedAttributes };
    },
    revertAttributesChanges(attributes) {
      attributes.forEach((attribute) => this.revertAttributeChanges(attribute));
    },
  },
};
</script>
